module.exports = __webpack_public_path__ + "static/media/krt03.0dc5dfcb.png";